import React from 'react';
import { observer } from 'mobx-react';
import debounce from 'lodash/debounce';
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import Carousel, { Modal, ModalGateway, carouselComponents } from 'react-images';
import pageStore from 'stores/Page/AgencyDetails/DetailsPageStore';

import * as api from 'Api';
import * as utils from 'Utils';
import * as constants from 'Constants';
import './styles.scss';



@observer
class CustomContainer extends React.Component {
  render() {
    return (
      <div className="agency-screenshots-modal-wrapper">
        <carouselComponents.Container {...this.props}/>
      </div>
    );
  }
}


@observer
class ScreenshotsLightBox extends React.Component {
  render() {
    return (
      <ModalGateway>
        {pageStore.displayScreenshot ? (
          <Modal onClose={() => pageStore.toggleDisplayScreenshot()}>
            <Carousel
              views={pageStore.screenshotsViews}
              currentIndex={pageStore.screenshotIndex}
              components={{ Container: CustomContainer }}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    );
  }
}



@observer
class MainAttribute extends React.Component {
  constructor (props) {
    super(props);
  }

  getLocation = () => {
    const agency = pageStore.agency;
    const listing = agency.listing;

    let locations = [];
    if (listing.region) locations.push(utils.capitalizeFirstLetter(listing.region.toLowerCase()));

    let option = pageStore.countryOptions.filter((option) => option.id === listing.countryAlpha2)[0];
    if (option) locations.push(option.label);

    return locations.join(", ");
  };

  render() {
    const agency = pageStore.agency;
    const listing = agency.listing;

    return (
      <div className="agency-attribute">
        <img className="agency-logo" src={listing.logoMedia.src} />
        <h1 className="agency-name">{agency.name}</h1>
        <div className="agency-location">{this.getLocation()}</div>
        <div className="agency-tagline">{listing.tagline}</div>
        <div className="agency-buttons">
          {listing.websiteUrl ? (
            <a href={listing.websiteUrlWithUtm} className="agency-button" target="_blank" rel="nofollow noopener">View Website</a>
          ): null}

          {listing.contactEmail ? (
            <a href={`mailto:${listing.contactEmail}`} className="agency-button">Email Us</a>
          ): null}
        </div>
      </div>
    );
  }
}


@observer
class StartingPriceAttribute extends React.Component {
  constructor (props) {
    super(props);
  }

  getStartingPrice = () => {
    const agency = pageStore.agency;
    const listing = agency.listing;
    const startingPrice = parseInt(listing.startingPrice);
    return `US$ ${startingPrice}`;
  };

  render() {
    return (
      <div className="agency-attribute">
        <div className="agency-attribute-heading">Starting Price</div>
        <div className="agency-attribute-value">{this.getStartingPrice()}</div>
      </div>
    );
  }
}


@observer
class LanguagesAttribute extends React.Component {
  constructor (props) {
    super(props);
  }

  getLanguageLabels = () => {
    const agency = pageStore.agency;
    const listing = agency.listing;
    let labels = [];

    listing.languageOptionIds.forEach((id) => {
      let option = pageStore.languageOptions.filter((option) => option.id === id)[0];
      if (option) labels.push(option.label);
    })

    return labels;
  };

  render() {
    const labels = this.getLanguageLabels();
    if (labels.length === 0) return null;

    return (
      <div className="agency-attribute">
        <div className="agency-attribute-heading">Languages</div>
        <ul className="agency-attribute-list">
          {labels.map((label) =>
            <li key={uniqueId()}>{label}</li>
          )}
        </ul>
      </div>
    );
  }
}


@observer
class SpecialitiesAttribute extends React.Component {
  constructor (props) {
    super(props);
  }

  getSpecialityLabels = () => {
    const agency = pageStore.agency;
    const listing = agency.listing;
    let labels = [];

    listing.specialityOptionIds.forEach((id) => {
      let option = pageStore.specialityOptions.filter((option) => option.id === id)[0];
      if (option) labels.push(option.label);
    })

    return labels;
  };

  render() {
    const labels = this.getSpecialityLabels();
    if (labels.length === 0) return null;

    return (
      <div className="agency-attribute">
        <div className="agency-attribute-heading">Specialities</div>
        <ul className="agency-attribute-list">
          {labels.map((label) =>
            <li key={uniqueId()}>{label}</li>
          )}
        </ul>
      </div>
    );
  }
}


@observer
class PlatformsAttribute extends React.Component {
  constructor (props) {
    super(props);
  }

  getPlatformLabels = () => {
    const agency = pageStore.agency;
    const listing = agency.listing;
    let labels = [];

    listing.platformOptionIds.forEach((id) => {
      let option = pageStore.platformOptions.filter((option) => option.id === id)[0];
      if (option) labels.push(option.label);
    })

    return labels;
  };

  render() {
    const labels = this.getPlatformLabels();
    if (labels.length === 0) return null;

    return (
      <div className="agency-attribute">
        <div className="agency-attribute-heading">Platforms</div>
        <ul className="agency-attribute-list">
          {labels.map((label) =>
            <li key={uniqueId()}>{label}</li>
          )}
        </ul>
      </div>
    );
  }
}

@observer
class Screenshot extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    const { screenshot, showScreenshot } = this.props;
    return (
      <div className="agency-screenshot">
        <img className="agency-screenshot-img" src={screenshot.media.src} onClick={showScreenshot} />
        <div className="agency-screenshot-desc">{screenshot.desc}</div>
      </div>
    );
  }
}

@observer
class Testimonial extends React.Component {
  constructor (props) {
    super(props);
  }

  render() {
    const { testimonial } = this.props;

    return (
      <div className="agency-testimonial-item">
        <div className="testimonial-content">{testimonial.content}</div>
        <div className="testimonial-person">
          <img src={testimonial.logoMedia.src} className="testimonial-avatar" />
          <div className="testimonial-person-info">
            <div className="testimonial-person-name">{testimonial.personName}</div>
            <div className="testimonial-person-credentials">{testimonial.personCredentials}</div>
          </div>
        </div>
      </div>
    );
  }
}


@observer
class AgencyDetails extends React.Component {
  constructor (props) {
    super(props);
  }

  showScreenshot = (idx) => {
    pageStore.toggleDisplayScreenshot();
    pageStore.setScreenshotIndex(idx);
  };

  render() {
    const agency = pageStore.agency;
    const listing = agency.listing;

    return (
      <div className="agency-details">
        <div className="agency-breadcrumbs">
          <a href="/agencies" className="agency-breadcrumb">
            <Icon.Bp icon="chevron-left" />
            <div className="agency-breadcrumb-text">Find Experts</div>
          </a>
        </div>

        <div className="agency-details-main">
          <div className="agency-attributes">
            <MainAttribute />
            <StartingPriceAttribute />
            <LanguagesAttribute />
            <SpecialitiesAttribute />
            <PlatformsAttribute />
          </div>

          <div className="agency-content">
            <div className="agency-article" dangerouslySetInnerHTML={{__html: listing.descHtml}}></div>
            {listing.screenshots.length > 0 ? (
              <div className="agency-screenshots">
                <h3>Screenshots</h3>
                <div className="screenshots-grid">
                  {listing.screenshots.map((screenshot, idx) =>
                    <Screenshot
                      key={idx}
                      screenshot={screenshot}
                      showScreenshot={() => this.showScreenshot(idx)}
                    />
                  )}
                </div>
              </div>
            ): null}

            {listing.testimonials.length > 0 ? (
              <div className="agency-testimonials">
                <h3>Testimonials</h3>
                <div className="testimonials-grid">
                  {listing.testimonials.map((testimonial) =>
                    <Testimonial
                      key={uniqueId()}
                      testimonial={testimonial}
                    />
                  )}
                </div>
              </div>
            ): null}
          </div>

        </div>

        <ScreenshotsLightBox />
      </div>
    );
  }
}



export default AgencyDetails;
